import { InputTextarea } from 'primereact/inputtextarea';
import { classNames } from 'primereact/utils';
import React from 'react';
import Flex from '../shared-styles/flexi';

function InputArea({value,label='',placeholder='',width="300px",height="200px",error='',onChange,...props}) {
    return (
        <Flex direction='column' alignItems='start' gap='6px'>
            <label className="font-bold">{label}</label>
            <InputTextarea {...props} style={{'width':width, height:height}} placeholder={placeholder ? placeholder : label} value={value} onChange={(e) => onChange(e.target.value)} required className={classNames({ 'p-invalid': error })} />
            {error && <small className="p-error">{error}</small>}
        </Flex>
    );
}

export default InputArea;